// @flow
import * as React from 'react';

import { ReactionContainer } from 'chat/components/Reaction';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import MessageItemBody from 'chat/components/Stream/components/MessageItemBody.jsx';
import MessageReactions from 'messages/components/MessageReactions.jsx';
import Text from 'components/Text.jsx';
import UserAvatar from 'users/components/UserAvatar.jsx';

import './styles/MessageView.scss';

type Props = {
  message: *,
  token?: string,
  recipientUuid?: string,
};

export class MessageView extends React.Component<Props> {
  renderAnnouncementHeader() {
    const { message } = this.props;
    const { group } = message;

    if (!group || message.type !== 'broadcast') {
      return null;
    }

    return (
      <div className="MessageView-head">
        <GroupAvatar className="MessageView-announcementBadge" group={Group.fromJSON(group)} />
        <div className="MessageView-head-classInfo">
          <Text className="MessageView-groupName" weight="semibold" truncate>
            {group.className}
          </Text>
        </div>
      </div>
    );
  }

  renderReactions() {
    const { message, token, recipientUuid } = this.props;

    if (!message.chat) {
      return null;
    }

    return (
      <ReactionContainer messageUuid={message.uuid} chatUuid={message.chat.uuid} token={token}>
        {({ reactionSummary, addReactionToSummary, removeReactionFromSummary }) => (
          <MessageReactions
            recipientUuid={recipientUuid}
            reactionSummary={reactionSummary}
            addReactionToSummary={addReactionToSummary}
            removeReactionFromSummary={removeReactionFromSummary}
          />
        )}
      </ReactionContainer>
    );
  }

  render() {
    const { message } = this.props;
    const { sender } = message;

    return (
      <div className="MessageView">
        {sender.__typename === 'UserSender' && (
          <Text className="MessageView-senderName" truncate>
            {sender.name}
          </Text>
        )}
        <div className="MessageView-row">
          {/* $FlowFixMe apollo incorrectly defines contactabilityStatus on a
            UserSender as a string instead of an enum */}
          <UserAvatar size="small" user={sender} className="MessageView-avatar" />
          <div className="MessageView-container">
            {this.renderAnnouncementHeader()}
            <div className="MessageView-content">
              <MessageItemBody item={message} />
            </div>
          </div>
        </div>
        {message.canReact && this.renderReactions()}
      </div>
    );
  }
}

export default MessageView;
